import React from 'react'
import styled from 'styled-components'
import { Devices } from '@raysync/common/theme'
import intl from 'react-intl-universal'
import { LargeWrapper } from '@raysync/common/components'
import { Title } from '../atoms'
const UseCasesSection = styled.section`
  padding: 80px 0 95px;
  background: #f5f7fb;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 0.6rem;
  }
`
const UseCasesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 56px;
  @media ${Devices.phone} {
    margin-top: 0.56rem;
    flex-wrap: wrap;
  }
`
const UseCasesItem = styled.div`
  border: 1px solid #e2e5e7;
  border-radius: 20px;
  width: 24%;
  height: 340px;
  padding: 68px 10px 40px;
  background-color: #fff;
  svg {
    display: block;
    height: 118px;
    margin: 0 auto 46px;
  }
  p {
    color: ${p => p.theme.color.textDarkPlus};
    line-height: 1.5;
    font-size: 20px;
    text-align: center;
    font-weight: 550;
    span {
      font-weight: 550;
    }
  }
  @media ${Devices.phone} {
    width: 48%;
    height: unset;
    padding: 0.68rem 0.2rem 0.4rem;
    margin-bottom: 0.4rem;
    svg {
      height: 1.18rem;
      margin-bottom: 0.46rem;
    }
    p {
      font-size: 0.2rem;
    }
  }
`
function UseCases({ items }) {
  return (
    <UseCasesSection>
      <LargeWrapper>
        <Title>{intl.get('solution.sdk.use-cases')}</Title>
        <UseCasesContainer>
          {items.map(i => (
            <UseCasesItem key={i.intlKey}>
              {i.svg}
              <p>{i.isHtml ? intl.getHTML(i.intlKey) : intl.get(i.intlKey)}</p>
            </UseCasesItem>
          ))}
        </UseCasesContainer>
      </LargeWrapper>
    </UseCasesSection>
  )
}

export default UseCases
